/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ahu_History_Key_Statep11Inputs */



/**
* | output |
* | --- |
* | "Left/top pump state" |
*
* @param {Ahu_History_Key_Statep11Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const ahu_history_key_statep11 = /** @type {((inputs?: Ahu_History_Key_Statep11Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ahu_History_Key_Statep11Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Left/top pump state")
	return /** @type {LocalizedString} */ ("État pompe gauche/haute")
});
export { ahu_history_key_statep11 as "ahu_history_key_stateP1" }